import { useEffect, useState } from "react";
import { FGM } from "../brand";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { label: "STORY", href: "#manifesto", id: "nav-link-story" },
        { label: "SHOP", href: "#shop", id: "nav-link-shop" },
        { label: "LOOKBOOK", href: "#lookbook", id: "nav-link-lookbook" },
        { label: "PARTNERS", href: "#partners", id: "nav-link-partners" },
        { label: "AMBASSADOR", href: "#ambassador", id: "nav-link-ambassador" },
        { label: "BLOG", href: "/blog", id: "nav-link-blog" },
    ];

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-black/80 backdrop-blur-xl border-b border-white/10"
                    : "bg-transparent"
            }`}
        >
            <a
                href="/drops/ascent"
                data-testid="shipping-announcement-bar"
                className="block bg-[#E63946] text-white text-center text-[10px] tracking-[0.3em] uppercase font-display py-1.5 px-4 hover:bg-red-600 transition-colors"
            >
                <span className="hidden md:inline">⚡ 10% OFF · Code <strong>SUMMERHEAT</strong> · </span>
                <span className="md:hidden">⚡ Code <strong>SUMMERHEAT</strong> · 10% Off · </span>
                <span className="opacity-90">FGM ASCENT Drops Sept 1 — Join Waitlist →</span>
            </a>
            <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
                    <img
                        src={FGM.logos.white}
                        alt="FGM Apparel"
                        className="h-10 w-10 object-contain"
                    />
                    <span className="hidden sm:block font-display text-xl tracking-[0.25em] text-white">
                        FGM<span className="text-white/40"> / APPAREL</span>
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a key={l.id} data-testid={l.id} href={l.href} className="nav-link">
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#ambassador"
                    data-testid="nav-cta-apply"
                    className="hidden md:inline-flex items-center gap-2 font-display text-sm tracking-[0.2em] bg-white text-black px-5 py-3 hover:bg-[#E63946] hover:text-white transition-colors uppercase"
                >
                    Apply Now
                    <span aria-hidden>→</span>
                </a>

                <button
                    data-testid="nav-mobile-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-white p-2"
                    aria-label="Toggle menu"
                >
                    <div className="w-6 h-[2px] bg-white mb-[5px]"></div>
                    <div className="w-6 h-[2px] bg-white mb-[5px]"></div>
                    <div className="w-4 h-[2px] bg-white ml-auto"></div>
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <a
                                key={l.id}
                                data-testid={`mobile-${l.id}`}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="nav-link text-lg"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#ambassador"
                            onClick={() => setOpen(false)}
                            className="btn-primary mt-2 w-full"
                        >
                            Apply Now
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
